import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterOutlet} from '@angular/router';
import {ConfirmDialogComponent} from '@core/components/confirm-dialog/confirm-dialog.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ToastModule} from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, ConfirmDialogComponent, ConfirmDialogModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly title = 'MyCodi Admin';

  constructor(private titleService: Title) {
    this.titleService.setTitle(this.title);
  }
}
